export const selectPermissionHolderType = type => selectedPermissionHolder => ({
    type,
    selectedPermissionHolder
})

export const removeOwnerViewer = type => (ownerViewerType, ownerViewerId) => ({
    type,
    ownerViewerType,
    id: ownerViewerId
})

export const searchAddOwnersViewers = type => searchTerm => ({
    type,
    searchTerm
})

export const searchAddOwnersViewersResponse = type => ({ data }) => ({
    type,
    data
})

export const selectAddOwnerViewer = type => (ownerViewer, ownerViewerType) => ({
    type,
    ownerViewer,
    ownerViewerType
})
